import {
  selectUI,
  titleUI,
} from '@department-of-veterans-affairs/platform-forms-system/web-component-patterns';

import {
  stateLabels,
  stateSelectSchema,
} from '../../schema-helpers/state-select';

const pageTitle = 'State of property';

const stateOfPropertyPage = {
  uiSchema: {
    ...titleUI(pageTitle),
    stateOfProperty: selectUI({
      title: 'Select state',
      labels: stateLabels,
      errorMessages: {
        required: 'Select state of property',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['stateOfProperty'],
    properties: {
      stateOfProperty: stateSelectSchema,
    },
  },
  title: pageTitle,
};
export default stateOfPropertyPage;
